import { useCallback, useState } from 'react';

const GENERIC_NETWORK_ERROR = -100;

function getFormattedError(error) {
    const message = error.httpResult
        ? error.httpResult.statusText
        : error.message;

    const statusCode = error.httpResult
        ? error.httpResult.status
        : GENERIC_NETWORK_ERROR;

    return {
        message,
        name: error.name,
        stack: error.stack,
        statusCode,
    };
}

export function useNetworkError() {
    // eslint-disable-next-line no-unused-vars
    const [_, setError] = useState();
    return useCallback(
        (error) => {
            setError(() => {
                throw getFormattedError(error);
            });
        },
        [setError]
    );
}
